import { IConfig } from '@cian/config/shared';
import { TOfferChatOnboardingItem } from 'shared/types/chatOnboarding';

import { TOfferDataParam } from '../types';

interface IParams {
  config: IConfig;
  data: TOfferDataParam;
}

export function getOfferChatOnboarding({ config, data }: IParams): TOfferChatOnboardingItem {
  const isEnabled = config.get<boolean>('Newbuilding.CianChatOnboarding.Enabled');
  const onboardingText =
    config.get<string>('Newbuilding.CianChatOnboarding.Text') ?? 'Теперь можно написать застройщику в чате';

  if (!isEnabled || data.newbuilding) {
    return null;
  }

  const offer = data.offersSerialized.find(({ chat, newbuilding }) =>
    Boolean(newbuilding && newbuilding.isFromBuilder && chat?.canSendMessage),
  );

  if (offer) {
    return {
      onboardingOfferId: offer.id,
      wasChatOpened: false,
      onboardingText,
    };
  }

  return null;
}
